import { Icons } from '@kg-internal/pv3-uikit';

import './FormError.scss';

type Props = {
  error: string | undefined;
};
const FormError = ({ error }: Props) =>
  error ? (
    <div className='error'>
      <p className='error-message'>
        {Icons.WarningNotifRed} {error}
      </p>
    </div>
  ) : null;

export default FormError;
